import {fragments} from "../../fragments";
import {Invoke}    from "../../invoke";

import {SideEffectRender} from "./side-effect-render";

export const RenderValueNode = ({value, setValueGetter, renderNext}) => fragments(
    Invoke({
        props: value,
        action: ({getLatestProps}) => {
            setValueGetter(getLatestProps);
        },
    }),

    SideEffectRender({
        isActive: renderNext.isActive,
        render: renderNext.render,
    }),
);
